// Lịch hẹn & công việc: kiểu từ hợp đồng crm, nhãn / icon theo loại việc, lưới tuần theo giờ Việt Nam.
import { crm } from '@cathouse/contracts';
import { weekdayOf } from '@/shared/lib';
import type { IconName } from '@/shared/ui';

/** Dòng lịch hẹn trong danh sách (crm.TaskRow). */
export type Task = crm.TaskRow;
export type TaskView = crm.TaskView;
export type TaskList = crm.TaskList;
export type TaskCounts = crm.TaskCounts;
export type TaskType = crm.TaskType;
export type TaskTab = crm.TaskTab;

export const TASK_TYPES = crm.TASK_TYPES;
export const TASK_TABS = crm.TASK_TABS;
export const TASK_TYPE_LABEL = crm.TASK_TYPE_LABEL;
export const TASK_TYPE_OPTIONS: [TaskType, string][] = TASK_TYPES.map((t) => [t, TASK_TYPE_LABEL[t]]);
export const TASK_ICON: Record<TaskType, IconName> = { viewing: 'pin', call: 'phone', meet: 'users', payment: 'banknote', doc: 'file', other: 'calendar' };

/** Bộ lọc danh sách: staffId vắng = "Cả đội" (mọi người trong phạm vi tasks.view); weekOf chỉ dùng cho tab week. */
export interface TaskFilters {
  tab: TaskTab;
  staffId?: string;
  weekOf?: string;
}

/** Tiêu đề mặc định server đặt khi để trống (defaultTaskTitle). */
export const defaultTaskTitle = (type: TaskType, customerName: string | null | undefined) => `${TASK_TYPE_LABEL[type]}${customerName ? ` – ${customerName}` : ''}`;

/** Cộng n ngày vào ngày 'YYYY-MM-DD' (lịch, không phụ thuộc múi giờ máy). */
export function addDays(dk: string, n: number) {
  const [y, m, d] = dk.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}
/** Thứ Hai của tuần chứa ngày dk. */
export const mondayOf = (dk: string) => addDays(dk, -((weekdayOf(dk) + 6) % 7));

const WD = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
/** 7 ngày từ thứ Hai: { key: 'YYYY-MM-DD', label: 'T2 19/10' }. */
export function weekDays(monday: string) {
  return WD.map((w, i) => {
    const key = addDays(monday, i);
    return { key, label: `${w} ${key.slice(8, 10)}/${key.slice(5, 7)}` };
  });
}
